import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTrainingDocument,
  CreateTrainingMutation,
  CreateTrainingMutationVariables,
  TrainingsCategoriesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<CreateTrainingMutation, CreateTrainingMutationVariables>

export const useCreateTraining = (options?: Options) => {
  const [createTraining, { loading }] = useMutation(CreateTrainingDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.createTrainingsTraining,
  })

  return {
    loading,
    create(variables: CreateTrainingMutationVariables) {
      return createTraining({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingsCategoriesDocument],
      })
    },
  }
}
